import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    const swiperEl = element.querySelector(".video_slider");
    const nextBtn = element.querySelector(".swiper-button-next");
    const prevBtn = element.querySelector(".swiper-button-prev");

    const swiper = new Swiper(swiperEl, {
        modules: [Autoplay, Navigation, Pagination],
        slidesPerView: 1,
        speed: data.transition ? data.transition : 300,
        loop: true,
        spaceBetween: 15,
        autoplay: data.timeout ? {delay: data.timeout} : false,
        autoHeight: true,
        init: false,
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        pagination: {
            el: element.querySelector(".swiper-pagination"),
            type: 'bullets',
            clickable: true
        }
    });

    const bulletsBlock = element.querySelector('.nav__bullets_block');

    const updatePositions = () => {
        const activeSlide = swiperEl.querySelector('.swiper-slide-active');
        if (!activeSlide) return;

        const title = activeSlide.querySelector('.video__item_title');
        const media = activeSlide.querySelector('.media__block');

        const titleHeight = title ? title.offsetHeight : 0;
        const mediaRect = media ? media.getBoundingClientRect() : null;

        if (mediaRect && nextBtn && prevBtn) {
            let top = mediaRect.height / 2;
            nextBtn.style.top = top + 'px';
            nextBtn.style.transform = 'translateY(-50%)';

            prevBtn.style.top = top + 'px';
            prevBtn.style.transform = 'translateY(-50%)';
        }

        if (mediaRect && bulletsBlock) {
            let bottom = window.innerWidth < 768 ? 20 : 30;
            bulletsBlock.style.bottom = `${bottom + titleHeight}px`;
        }
    }

    swiper.on('init', updatePositions);
    swiper.on('slideChangeTransitionEnd', updatePositions);
    swiper.init();
    window.addEventListener('resize', updatePositions);

}
